export const digitsMask = value => {
  return value.replace(/\D/g, '');
};

export const matriculaMask = value => {
  value = value
    .replace(/\D/g, '')
    .replace(/(\d{4})(\d{1})/, '$1-$2')
    .replace(/(-\d{1})\d+?$/, '$1');

  return value;
};

export const cpfMask = value => {
  value = value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');

  return value;
};

export const phoneMask = value => {
  let valueFormat = value.replace(/\D/g, '');

  if (valueFormat.length < 11) {
    valueFormat = valueFormat
      .replace(/\D/g, '')
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .replace(/(\d{4})\d+?$/, '$1');
  } else {
    valueFormat = valueFormat
      .replace(/\D/g, '')
      .replace(/^(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(\d{4})\d+?$/, '$1');
  }
  
  return valueFormat;
};

export const cepMask = value => {
  value = value
    .replace(/\D/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})\d+?$/, '$1');

  return value;
};

export const ouvidoriaProtocoloMask = value => {
  value = value
    .replace(/\D/g, '')
    .replace(/(\d{4})(\d)/, '$1.$2')
    .replace(/(\.\d{2})(\d{1,2})/, '$1.$2')
    .replace(/(\.\d{3})\d+?$/, '$1');

  return value;
};

export const editalMask = value => {
  value = value
    .replace(/\D/g, '')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
    
  return value;
};
